<template>
  <div class="enriched-input">
    <PflegeInput
      v-model="modelValue"
      :type="calcedType"
      :autocomplete="calcedAutofill"
      :error-message="errorMessage"
      :has-error="hasError"
      :has-picker="props.type !== 'birthdate'"
      :inputmode="props.type === 'postleitzahl' ? 'numeric' : null"
      :has-success="hasSuccess"
      :label="label"
      :name="utils.toSystemFriendlyString(label)"
      :persistent-hint="persistentHint"
      :placeholder="placeholder"
      :required="required"
      @blur="$emit('blur', $event)"
      @update:model-value="$emit('input', $event)"
    >
      <template #hint>
        <slot name="hint"></slot>
      </template>
    </PflegeInput>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import usePflegeUtils from '../../composable/usePflegeUtils'

const utils = usePflegeUtils()

defineEmits(['input', 'blur'])
const props = defineProps({
  label: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    required: false,
    default: null
  },
  name: {
    type: String,
    required: false,
    default: null
  },
  type: {
    type: String,
    required: false,
    default: null
  },
  required: {
    type: Boolean,
    required: false,
    default: true
  },
  hasSuccess: {
    type: Boolean,
    required: false,
    default: false
  },
  hasError: {
    type: Boolean,
    required: false,
    default: false
  },
  persistentHint: {
    type: Boolean,
    required: false,
    default: false
  },
  errorMessage: {
    type: String,
    required: false,
    default: null
  }
})

const modelValue = defineModel({ type: String })

const calcedType = computed(() => {
  switch (props.type) {
    case 'email':
      return 'email'
    case 'telefonnummer':
      return 'tel'
    case 'bday':
      return 'date'
    default:
      return 'text'
  }
})

const calcedAutofill = computed(() => {
  switch (props.type) {
    case 'vorname':
    case 'dritte_vorname':
      return 'given-name'
    case 'nachname':
    case 'dritte_nachname':
      return 'family-name'
    case 'email':
      return 'email'
    case 'telefonnummer':
      return 'tel'
    case 'strasse':
      return 'address-line1'
    case 'hausnummer':
      return 'address-line2'
    case 'postleitzahl':
      return 'postal-code'
    case 'ort':
      return 'address-level2'
    case 'bday':
      return 'bday'
    case 'versicherungsnummer':
      return 'off'
    default:
      return 'on'
  }
})
</script>
